/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */
import React from "react";
import MainView from "../MainView/MainView";
import AdvancedView from "../AdvancedView/AdvancedView";
import StartView from "../StartView/StartView";
import { IMainFrameState, MainFrameCommands, Views } from "./MainframeViewModel";

const mainFrameCommands = new MainFrameCommands();
const cmds = mainFrameCommands.Cmds;

const initialState: IMainFrameState = {
    currentView: Views.Start
};

export const MainFrame = (): JSX.Element => {
    const [state, dispatch] = React.useReducer(mainFrameCommands.Reducer, initialState);
    const mainFrameVM = { state, cmds, dispatch };

    return (
        <main>
            {state.currentView === Views.Start && <StartView mainFrameVM={mainFrameVM} />}

            {state.currentView === Views.Main && <MainView mainFrameVM={mainFrameVM} />}

            {state.currentView === Views.Advanced && <AdvancedView mainFrameVM={mainFrameVM} />}
        </main>
    );
};
